import type { ReploShopifyVariant } from "schemas/runtimeProduct";

import { isNullish } from "replo-utils/lib/misc";

export const variantIsOnSale = (variant: ReploShopifyVariant) => {
  // NOTE (Leo, 2026-07-27): Compare against `rawPrice`, not `price`. By the time a
  // variant reaches this check its `price` has been overwritten with a locale-formatted
  // display string (e.g. "1,349.00"), so `Number(price)` is NaN for any value with a
  // thousands separator, making the comparison always false. `rawPrice` is the
  // un-formatted numeric string, matching Shopify's raw `compareAtPrice`.
  if (isNullish(variant.compareAtPrice) || isNullish(variant.rawPrice)) {
    return false;
  }
  return Number(variant.compareAtPrice) > Number(variant.rawPrice);
};
